import { ForCIC } from "src/features/for-cic"
import React from "react"
import { DefaultLayout } from "src/components/Layout"
import { Auth } from "src/features/auth"
import Head from "next/head"

const ForCICPage: React.VFC = () => {
  return (
    <DefaultLayout>
      <Head>
        <title>審査 | for CS</title>
      </Head>
      <Auth>
        <ForCIC mainExaminationScoresType="undone" />
      </Auth>
    </DefaultLayout>
  )
}

export default ForCICPage
